import { render } from "./ElevationDemo.vue?vue&type=template&id=60f5fd37&scoped=true"
import script from "./ElevationDemo.vue?vue&type=script&lang=js"
export * from "./ElevationDemo.vue?vue&type=script&lang=js"

import "./ElevationDemo.vue?vue&type=style&index=0&id=60f5fd37&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f5fd37"]])

export default __exports__